import {Controller} from "stimulus"
import $ from 'jquery';
import jsQR from 'jsqr';
import {blockBody, unblockBody} from './blockUI_controller'
import bootbox from "bootbox";

export default class extends Controller {
    static targets = ["reader", "stopButton", "startButton","modal"]

    initialize() {

    }

    connect() {
        this.scanning = false;
        this.stream = null;
        this.animationId = null;

        setTimeout(()=>{
            this.modal = new bootstrap.Modal(this.modalTarget,{
                keyboard: false,
                backdrop: 'static',
                focus: true
            })
        },500)

        navigator.geolocation.getCurrentPosition((pos) => {
            const {latitude, longitude} = pos.coords
            console.log(latitude, longitude)
        }, (positionError) => {
            console.log(positionError)
        })

    }

    validate_by_number(){
        let context = this;
        bootbox.dialog({
            message: `<div class="row">
                        <div class="col-12">
                            <label for="validate_references">No. de Voucher</label>
                            <input type="text" id="validate_references" class="form-control" required>
                        </div>,
                        <div class="col-12">
                            <label for="validate_ticket">No. de Ticket</label>
                            <input type="text" id="validate_ticket" class="form-control" required>
                        </div>
                    </div>`,
            buttons: {
                cancel: {
                    label: 'Cerrar',
                    callback: function (e) {}
                },
                ok: {
                    label: 'Validar',
                    callback: function (e) {
                      e.preventDefault();
                      let references = $('#validate_references');
                      let ticket = $('#validate_ticket');

                      if(references.val().isEmpty() || ticket.val().isEmpty()){
                        references.addClass('is-invalid');
                        ticket.addClass('is-invalid');

                        toastr.error('Debe completar todos los campos para validar el ticket de combustible', 'Error de validación');
                        return false;
                      }else{
                          context.handleQRCode({
                              validate_reference: references.val(),
                              validate_ticket: ticket.val(),
                              validate_by_number: true
                          })
                      }
                    }
                }
            }
        })
    }

    view_tickets(){
        let context = this;
        bootbox.dialog({
            message: `<div class="row">
                        <div class="col-12">
                            <label for="validate_references">No. de Voucher</label>
                            <input type="text" id="validate_references" class="form-control" required>
                        </div>
                    </div>`,
            buttons: {
                cancel: {
                    label: 'Cerrar',
                    callback: function (e) {}
                },
                ok: {
                    label: 'Buscar',
                    callback: function (e) {
                        e.preventDefault();
                        let references = $('#validate_references');

                        if(references.val().isEmpty()){
                            references.addClass('is-invalid');
                            toastr.error('Los campos son de llenado obligatorio', 'Error de validación');
                            return false;
                        }else{
                           location.href = `${location.origin}/ticket/view?ref=${references.val()}`
                        }
                    }
                }
            }
        })
    }

    modal_show(){
        this.setupCamera();
        this.modal.show();
    }

    modal_hide(){
        this.stopCamera();
        this.modal.hide()
    }
    async setupCamera() {
        try {
            const constraints = {
                video: {
                    facingMode: "environment",
                    width: { ideal: 1280 },
                    height: { ideal: 720 }
                }
            };

            this.stream = await navigator.mediaDevices.getUserMedia(constraints);
            this.readerTarget.srcObject = this.stream;
            this.readerTarget.setAttribute("playsinline", true);
            await this.readerTarget.play();

            this.scanning = true;
            this.scanQRCode();

        } catch (error) {
            console.error("Error accediendo a la cámara:", error);
        }
    }

    // Método para detener la cámara
    stopCamera() {
        this.scanning = false;

        // Detener el animation frame
        if (this.animationId) {
            cancelAnimationFrame(this.animationId);
            this.animationId = null;
        }

        // Detener todos los tracks de la cámara
        if (this.stream) {
            this.stream.getTracks().forEach(track => {
                track.stop();
            });
            this.stream = null;
        }

        // Limpiar el video
        if (this.readerTarget) {
            this.readerTarget.srcObject = null;
        }

        console.log("Cámara detenida");
    }

    // Método para reiniciar la cámara
    async startCamera() {
        if (this.stream) {
            this.stopCamera();
        }
        await this.setupCamera();
    }

    scanQRCode() {
        if (!this.scanning) return;

        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");

        const scan = () => {
            if (!this.scanning || !this.readerTarget || this.readerTarget.paused || this.readerTarget.ended) {
                return;
            }

            if (this.readerTarget.readyState === this.readerTarget.HAVE_ENOUGH_DATA) {
                canvas.width = this.readerTarget.videoWidth;
                canvas.height = this.readerTarget.videoHeight;
                context.drawImage(this.readerTarget, 0, 0, canvas.width, canvas.height);

                const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                const code = jsQR(imageData.data, imageData.width, imageData.height);

                if (code) {
                    this.handleQRCode(code.data);
                    return;
                }
            }

            this.animationId = requestAnimationFrame(scan);
        };

        scan();
    }

    handleQRCode(content) {
        console.log("QR escaneado:", content);
        let url = `${location.origin}/ticket/qr_validate`
        let data = { token: content }

        if(content.hasOwnProperty('validate_by_number') && content.validate_by_number === true){
            console.log(`${location.origin}/ticket/number_validate`)
            url = `${location.origin}/ticket/number_validate`
            data = content
        }
        $.ajax({
            url: url,
            type: 'POST',
            data: data,
            beforeSend: () => {
                this.modal_hide();
                blockBody('Validando Tiket de combustible...')

            },
            success: (data) => {
                $('#table').bootstrapTable('refresh')
                if(data.success){
                    blockBody(data.data,'#61bf5a','#61bf5a','#ffffff', 'fa-check fa-3x fa-fw')
                    setTimeout(()=>{
                        location.href = `${location.origin}/ticket/proof?token=${data.value.token}&ref=${data.value.references}`
                    },5000)
                }else{
                    blockBody(data.data, '#d43f34','#d43f34','#ffffff','fa-times fa-3x fa-fw')
                    setTimeout(()=>{
                       unblockBody();
                    },5000)
                }


            }
        })
    }

    disconnect() {
        this.stopCamera(); // Limpiar cuando el controller se desconecta
    }
}